import moment from 'moment';

export function LoadLocale(locale: string) {
  if (locale === 'en') return; //by default its there
  try {
    // eslint-disable-next-line local-rules/no-dynamic-moment-locale
    require(`moment/locale/${locale}`);
    moment.locale(locale);
  } catch (error) {
    console.error(error);
  }
}
